import { render, staticRenderFns } from "./LogicIcon.vue?vue&type=template&id=056894b8&scoped=true&"
import script from "./LogicIcon.vue?vue&type=script&lang=js&"
export * from "./LogicIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogicIcon.vue?vue&type=style&index=0&id=056894b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056894b8",
  null
  
)

export default component.exports